﻿
(() => {
    angular.module('fliptoWeb')
        .factory('newsApi', ['server', function (server) {

        //server api = /api/news/{int: pageIndex}
        var GETNEWSPAGEURL = "/api/news/";
        //server api = /api/article/{str: articleSlug}
        var GETARTICLEPOSTURL = "/api/article/";

        function postGetNewsPage(pageIndex: number) {
            return server.call('POST', GETNEWSPAGEURL + pageIndex, null, true);
        }
        function postGetArticle(slug: string) {
            return server.call('POST', GETARTICLEPOSTURL + slug, null, true);
        }

        return {
            GetNewsPage: postGetNewsPage,
            GetArticle: postGetArticle
        }
    }]);
})()

